"use strict";

var _underscore = require("underscore");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var INVITE_USER_FORM = {
  title: 'Add a member',
  saveLabel: 'Add',
  fields: {
    email: {
      kind: 'email'
    }
  }
};
var OrgEventList = /*#__PURE__*/function () {
  OrgEventList.$inject = ["$rootScope", "$filter", "orgService", "eventService", "userService", "modalService"];
  /* @ngInject */
  function OrgEventList($rootScope, $filter, orgService, eventService, userService, modalService) {
    var _this = this;
    _classCallCheck(this, OrgEventList);
    this.orgService = orgService;
    this.eventService = eventService;
    this.modalService = modalService;
    this.currentUser = userService.getCurrentUser();
    this.userIsSuperAdmin = userService.matchesRoles({
      globalRole: 'superadmin'
    });
    this.eventInstancesByPeriods = $filter('eventInstancesByPeriods');
    this.setFlashMessage = function (message, level) {
      return $rootScope.setFlashMessage(message, level);
    };
    this.views = [{
      id: 'current',
      label: 'Live'
    }, {
      id: 'future',
      label: 'Future'
    }, {
      id: 'past',
      label: 'Past'
    }, {
      id: 'templates',
      label: 'Templates'
    }];
    this.activeViewIndex = 0;
    this.loading = true;
    this.joined = {};
    this.isOrgAdmin = (0, _underscore.memoize)(function (org) {
      return orgService.isMatchesOrgPermission('admin', org);
    });
    this.isMemberOf = (0, _underscore.memoize)(function (eventId) {
      return (0, _underscore.find)(_this.currentUser.roles, function (_ref) {
        var type = _ref.type,
          role = _ref.role,
          event_id = _ref.event_id;
        return type === 'event_permission' && role !== 'revoked' && event_id === eventId;
      });
    });
    this.userCanAddMembersToTeam = (0, _underscore.memoize)(function (orgId) {
      return userService.hasPermission('access_modification_realms.add_event_team_member', {
        org_id: orgId
      });
    });
    this.navigate = $rootScope.navigate;
  }
  _createClass(OrgEventList, [{
    key: "$onChanges",
    value: function $onChanges(changes) {
      var _this2 = this;
      if (changes.organisation && this.organisation) {
        this.loading = true;
        this.canJoinEvents = this.isOrgAdmin(this.organisation) || this.userCanAddMembersToTeam(this.organisation._id);
        this.orgService.getAllOrgEvents(this.organisation.name).then(function (data) {
          return _this2.sortEvents(data);
        }).finally(function () {
          return _this2.loading = false;
        });
      }
    }
  }, {
    key: "switchView",
    value: function switchView(id) {
      var _this3 = this;
      (0, _underscore.each)(this.views, function (view, index) {
        view.active = view.id === id;
        if (view.active) {
          _this3.activeViewIndex = index;
        }
      });
    }
  }, {
    key: "sortEvents",
    value: function sortEvents() {
      var _this4 = this;
      var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.eventCount = events.length;
      (0, _underscore.each)(this.views, function (view) {
        if (view.id === 'templates') {
          view.events = events.filter(function (e) {
            return e.is_template;
          });
        } else {
          view.events = _this4.eventInstancesByPeriods(events.filter(function (e) {
            return !e.is_template;
          }), view.id);
        }
      });
      var firstViewWithEvent = this.views.find(function (e) {
        return e.events.length > 0;
      }) || this.views[0];
      this.views = this.views.map(function (view) {
        return _objectSpread(_objectSpread({}, view), {}, {
          active: view === firstViewWithEvent
        });
      });
      this.switchView(firstViewWithEvent.id);
    }
  }, {
    key: "joinEvent",
    value: function joinEvent(event) {
      var _this5 = this;
      if (!this.canJoinEvents) {
        return;
      }
      var eventId = event._id;
      var eventNodeName = this.eventService.getEventInstanceNodeName(event);

      // needs to be called on cloud node
      this.eventService.addEventTeamMember(event, this.currentUser.name, 'manager', eventNodeName).then(function () {
        _this5.setFlashMessage("You were added to ".concat(_this5.getEventName(event)));
        _this5.joined[eventId] = true;
      }).catch(function (error) {
        console.error(error);
        _this5.setFlashMessage('Failed to join the event team', 'danger');
      });
    }
  }, {
    key: "inviteToEvent",
    value: function inviteToEvent(event) {
      var _this6 = this;
      if (!this.canJoinEvents) {
        return;
      }
      var email;
      this.modalService.openModalWithForm(INVITE_USER_FORM).then(function (model) {
        var eventNodeName = _this6.eventService.getEventInstanceNodeName(event);

        // needs to be called on cloud node
        _this6.eventService.addEventTeamMember(event, email = model.email, 'manager', eventNodeName).then(function () {
          var _event$description, _event$description$ti;
          return _this6.setFlashMessage("".concat(email, " was added to ").concat(event.eventname || ((_event$description = event.description) === null || _event$description === void 0 ? void 0 : (_event$description$ti = _event$description.title) === null || _event$description$ti === void 0 ? void 0 : _event$description$ti.en) || 'workspace'));
        }).catch(function (error) {
          var msg = "Failed to add ".concat(email, " to workspace");
          var errorCode = error.status;
          if (errorCode === 404 || errorCode === 403) {
            msg = 'This user is not a Member in this Organization. In order to add this user to the Workspace, please add this user as an Organization Member first.';
          }
          _this6.setFlashMessage(msg, 'danger');
        });
      });
    }
  }, {
    key: "getEventName",
    value: function getEventName(event) {
      return this.eventService.getName(event);
    }
  }]);
  return OrgEventList;
}();
module.exports = angular.module('backstage.components.orgs.view-org.event-list', ['backstage.services']).component('bsOrgEventList', {
  templateUrl: '/src/angular/components/orgs/view-org/org-event-list/org-event-list.html',
  bindings: {
    organisation: '<'
  },
  controller: OrgEventList
}).name;